import { toLatinNumberingSystemLocale } from '../localeUtils';

// Starting char code for Arabic numbers minus the starting char code for English numbers
// const pseudoArToEnglishDiff = 1632 - 48;

const numericFormats = ['decimal', 'currency', 'percent', 'unit'];
const toIntlDateTimeFormatOptions = format => {
  const [datetime, length] = format.split('_');
  if (datetime === 'datetime') {
    if (length === 'long') {
      return {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
    } else if (length === 'medium') {
      return {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
    }
    return {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };
  }
  if (datetime === 'time') {
    if (length === 'long') {
      return {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };
    }
    return {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };
  }
  if (datetime === 'date') {
    if (length === 'long') {
      return {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      };
    }
    return {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    };
  }
  return {};
};

/**
 * A basic implementation of the Formatter API. Feature support is limited to what is natively provided
 * in browser APIs. The supported formats are subject to change.
 */
export class BrowserFormatter {
  constructor(locale) {
    this.locale = locale;
    this.locale = locale.replace('_', '-');
  }
  formatDateTime(date, format) {
    const locale = toLatinNumberingSystemLocale(this.locale);
    return new Intl.DateTimeFormat(locale, toIntlDateTimeFormatOptions(format)).format(date);
  }
  parseDateTime(date, _format) {
    return Date.parse(date);
  }
  isDateTimeFormatSupported(format) {
    const [datetime, length] = format.split('_');
    return ['date', 'time', 'datetime'].includes(datetime) && ['long', 'short'].includes(length);
  }
  getDateTimeFormatType(format) {
    const [datetime] = format.split('_');
    switch (datetime) {
      case 'datetime':
      case 'date':
      case 'time':
        return datetime;
      default:
        return '';
    }
  }
  getDateTimeFormatPattern(_format) {
    throw new Error('getDateTimeFormatPattern is not yet supported in BrowserFormatter');
  }
  formatNumeric(number, format, numberFormatOptions) {
    const options = !!format ? {
      style: format
    } : undefined;
    const locale = toLatinNumberingSystemLocale(this.locale);

    /**
     * useGrouping will change 4 digit number formatting in pl-xx locale
     * eg. 1000 -> 1 000
     */
    const result = new Intl.NumberFormat(locale, {
      ...options,
      useGrouping: true,
      maximumFractionDigits: numberFormatOptions?.maximumFractionDigits,
      minimumFractionDigits: numberFormatOptions?.minimumFractionDigits
    }).format(number);
    return result;
  }
  parseNumeric(number, format) {
    const parsedValue = Number.parseFloat(number);
    if (format === 'percent') {
      return parsedValue / 100;
    }
    return parsedValue;
  }
  isNumericFormatSupported(format) {
    return numericFormats.includes(format);
  }
}
//# sourceMappingURL=BrowserFormatter.js.map